module.exports = __webpack_public_path__ + "img/btn_CNN_R.04e2c17e.png";